import { render, staticRenderFns } from "./Building.vue?vue&type=template&id=08cdf577&scoped=true&"
import script from "./Building.vue?vue&type=script&lang=js&"
export * from "./Building.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cdf577",
  null
  
)

export default component.exports